module.exports = __webpack_public_path__ + "static/media/submitIcon.c6b1c9af.svg";